'use client';

import clsx from 'clsx';
import { UIPriority } from '@/enums/ui-priorities';
import Button from '@/ui/Button';
import Checkbox from '@/ui/Checkox';
import { surfaceLayers } from '@/ui/overlay-layers';

const resolveCountBadgeSizeClassName = (count: number) => (count > 99 ? 'min-w-6 px-1' : 'w-4');

const resolveCountBadgePositionClassName = (count: number) => (count > 9999 ? 'left-0' : 'right-0');
const BASE_BADGE_CLASS_NAME =
    'absolute top-0 flex h-4 -translate-y-[20%] items-center justify-center rounded-full text-[9px]';
const SYNC_BADGE_CLASS_NAME = 'min-w-7 px-1 right-0 bg-blue-600/50 text-white';

type SelectionCountBubbleProps = {
    count: number;
    isSyncing?: boolean;
};

export const SelectionCountBubble = ({ count, isSyncing = false }: SelectionCountBubbleProps) => (
    <div
        className={`${BASE_BADGE_CLASS_NAME} ${isSyncing ? SYNC_BADGE_CLASS_NAME : `${resolveCountBadgeSizeClassName(count)} ${resolveCountBadgePositionClassName(count)} bg-blue-600 text-white`}`}
    >
        <span>{isSyncing ? '...' : count}</span>
    </div>
);

type TableHeaderSelectAllButtonProps = {
    selectedItemsCount: number;
    onAllPicked: () => void | Promise<void>;
    disabled?: boolean;
    isSyncing?: boolean;
    showSyncBubbleWhenEmpty?: boolean;
};

export const TableHeaderSelectAllButton = ({
    selectedItemsCount,
    onAllPicked,
    disabled = false,
    isSyncing = false,
    showSyncBubbleWhenEmpty = false,
}: TableHeaderSelectAllButtonProps) => (
    <div className="relative flex items-center overflow-visible">
        <Button
            type="button"
            className={clsx('w-8 px-1 whitespace-nowrap !min-h-7 !py-0.5', isSyncing && 'opacity-50')}
            priorityType={UIPriority.SECONDARY}
            uiSize="compact"
            onClick={() => {
                void onAllPicked();
            }}
            disabled={disabled}
        >
            Все
        </Button>
        {(selectedItemsCount > 0 || (isSyncing && showSyncBubbleWhenEmpty)) && (
            <SelectionCountBubble count={selectedItemsCount} isSyncing={isSyncing} />
        )}
    </div>
);

type TableFilterCheckboxHeaderCellProps = {
    isChecked: boolean;
    onChange: (checked: boolean) => void;
    isSyncing?: boolean;
};

export const TableFilterCheckboxHeaderCell = ({
    isChecked,
    onChange,
    isSyncing = false,
}: TableFilterCheckboxHeaderCellProps) => (
    <th
        className="sticky left-0 h-10 w-8 bg-gray-50 px-1 py-0 align-middle lg:w-[1%]"
        style={{ zIndex: surfaceLayers.surfaceStickyBase }}
    >
        <Checkbox
            isChecked={isChecked}
            setIsChecked={(value) => {
                onChange(value);
            }}
            ariaLabel="Выбрать текущую страницу таблицы"
            className={clsx(isSyncing && 'opacity-50')}
        />
    </th>
);
